import { render, staticRenderFns } from "./echartProdData.vue?vue&type=template&id=617b590a&scoped=true&"
import script from "./echartProdData.vue?vue&type=script&lang=js&"
export * from "./echartProdData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617b590a",
  null
  
)

export default component.exports